// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607150503/js/" + chunkId + "." + {"44":"4762697e","225":"4df43bf5","481":"102de1b8","486":"e94cee43","770":"c0745ca2"}[chunkId] + ".0.286234507600304.chunk.js";
};